(function () {
  'use strict';

  var MAX_MB = 20; // per-file cap; Apps Script chokes on huge base64 payloads

  function init() {
    var root = document.querySelector('[data-design-upload]');
    if (!root) return;

    var driveUrl     = root.getAttribute('data-drive-url') || '';
    var driveFolder  = root.getAttribute('data-folder') || 'Custom Design Uploads';
    var productTitle = (root.getAttribute('data-product-title') || '').trim();
    var required     = root.getAttribute('data-required') === 'true';

    var fileInput = root.querySelector('[data-design-file-input]');
    var dropBtn   = root.querySelector('[data-design-drop]');
    var listEl    = root.querySelector('[data-design-file-list]');
    var errorEl   = root.querySelector('[data-design-error]');

    // The snippet renders inside the product form, so the hidden property
    // input rides along with the theme's own AJAX add-to-cart.
    var form = root.closest('form') || document.querySelector('.product-single__form');

    var uploadedLinks  = []; // ["logo.svg: https://drive…", …]
    var pendingUploads = []; // in-flight upload promises
    var hiddenInput    = null;

    function syncProperty() {
      if (!form) return;
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[Design file]';
        form.appendChild(hiddenInput);
      }
      hiddenInput.value = uploadedLinks.join('   |   ');
    }

    function showError(show) {
      if (errorEl) errorEl.hidden = !show;
      root.classList.toggle('is-invalid', show);
      if (show) root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function renderRow(name) {
      var row = document.createElement('div');
      row.className = 'design-upload__file';
      var nameEl = document.createElement('span');
      nameEl.className = 'design-upload__file-name';
      nameEl.textContent = name;
      var statusEl = document.createElement('span');
      statusEl.className = 'design-upload__file-status';
      statusEl.textContent = 'Uploading…';
      var removeEl = document.createElement('button');
      removeEl.type = 'button';
      removeEl.className = 'design-upload__file-remove';
      removeEl.setAttribute('aria-label', 'Remove file');
      removeEl.innerHTML = '&times;';
      row.appendChild(nameEl);
      row.appendChild(statusEl);
      row.appendChild(removeEl);
      if (listEl) listEl.appendChild(row);
      return {
        setDone: function (link) {
          row.classList.add('is-done');
          statusEl.textContent = 'Uploaded ✓';
          if (link) uploadedLinks.push(link);
          syncProperty();
          showError(false);
          removeEl.addEventListener('click', function () {
            if (link) uploadedLinks = uploadedLinks.filter(function (l) { return l !== link; });
            syncProperty();
            row.remove();
          });
        },
        setError: function (msg) {
          row.classList.add('is-error');
          statusEl.textContent = msg || 'Upload failed — try again';
          removeEl.addEventListener('click', function () { row.remove(); });
        }
      };
    }

    function readAsPayload(file) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (ev) {
          var base64 = ev.target.result.split(',')[1];
          // Prefix with the product title so files are self-describing in Drive.
          var savedName = (productTitle ? productTitle + ' – ' : '') + file.name;
          resolve({ filename: savedName, mimeType: file.type || 'application/octet-stream', data: base64 });
        };
        reader.readAsDataURL(file);
      });
    }

    function uploadFiles(fileList) {
      if (!driveUrl) return;
      Array.prototype.slice.call(fileList).forEach(function (file) {
        var row = renderRow(file.name);
        if (file.size > MAX_MB * 1024 * 1024) {
          row.setError('Too large — max ' + MAX_MB + 'MB');
          return;
        }
        var p = readAsPayload(file)
          .then(function (payload) {
            return fetch(driveUrl, {
              method: 'POST',
              body: JSON.stringify({ files: [payload], folder: driveFolder }),
              redirect: 'follow',
              headers: { 'Content-Type': 'text/plain' }
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (result) {
            if (result && result.success && result.files && result.files.length) {
              var f = result.files[0];
              row.setDone(f.filename + ': ' + f.url);
            } else {
              row.setError();
            }
          })
          .catch(function () { row.setError(); });
        pendingUploads.push(p);
      });
    }

    if (dropBtn) dropBtn.addEventListener('click', function () { fileInput.click(); });
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        uploadFiles(fileInput.files);
        fileInput.value = '';
      });
    }
    ['dragenter', 'dragover'].forEach(function (ev) {
      root.addEventListener(ev, function (e) { e.preventDefault(); root.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      root.addEventListener(ev, function (e) { e.preventDefault(); root.classList.remove('is-drag'); });
    });
    root.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) uploadFiles(e.dataTransfer.files);
    });

    // ── Gate add-to-cart until a graphic is uploaded ─────────────────────
    if (form && required) {
      var resubmitting = false;
      form.addEventListener('submit', function (e) {
        if (resubmitting) { resubmitting = false; return; }
        if (uploadedLinks.length) return; // has a file — let the theme add normally

        // Uploads still in flight: hold the submit until they settle.
        if (pendingUploads.length) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var btn = form.querySelector('[data-add-to-cart]');
          if (btn) btn.classList.add('btn--loading');
          Promise.all(pendingUploads.map(function (p) { return p.catch(function () {}); }))
            .then(function () {
              if (btn) btn.classList.remove('btn--loading');
              if (uploadedLinks.length) {
                syncProperty();
                resubmitting = true;
                if (form.requestSubmit) form.requestSubmit();
                else form.submit();
              } else {
                showError(true);
              }
            });
          return;
        }

        // Nothing uploaded at all: block and point at the uploader.
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(true);
      }, true); // capture phase — runs before the theme's own handler
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
